import React from 'react';
import PropTypes from 'prop-types';
import ArchiveIcon from '@mui/icons-material/Archive';
import ActionButton from './ActionButton';

export default function ArchiveButton({
  label,
  onClick,
  sx,
  variant = 'contained',
  color = 'warning',
}) {
  return (
    <ActionButton
      variant={variant}
      color={color}
      label={label}
      onClick={onClick}
      startIcon={<ArchiveIcon />}
      sx={sx}
    />
  );
}

ArchiveButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
